import { IconExternalLink } from "@tabler/icons-react";
import { useState } from "react";

import { useOrg } from "~/contexts/orgProvider";
import { IS_DEVELOPMENT, IS_SANDBOX } from "~/env";
import { appConstants } from "~/shared/constants/app.constants";
import { Button, Text, tokens } from "~/ui";
import { routes } from "~/utils/routes";

import { OrgOnboardingModeModal } from "../_shared/modals/OrgOnboardingModeModal";
import { DangerAlert, InfoAlert, WarningAlert } from "../Alert";
import { OrgLink } from "../OrgLink";

const SandboxModeAlert = (): JSX.Element => (
  <WarningAlert>
    <Text c="primary" fw={500} ta="center">
      This is a Sandbox for testing. All data here will be reset on a regular basis.{" "}
      <Button
        compact
        component="a"
        target="_blank"
        href={appConstants.sandboxSupportUrl}
        rightIcon={<IconExternalLink size="1rem" />}
        variant="subtle"
      >
        Learn More
      </Button>
    </Text>
  </WarningAlert>
);

const DevelopModeAlert = () => (
  <WarningAlert>
    <Text c="primary" fw={500} ta="center">
      This is a Develop environment for testing. All data here will be reset on a regular basis.
    </Text>
  </WarningAlert>
);

const OrgDisabledAlert = () => {
  return (
    <DangerAlert>
      <Text color={tokens.color.content.warning} fw={500} ta="center">
        This Org has been disabled, to re-enabled it go to <OrgLink href={routes.superAdminOrgManagement}>Management Settings</OrgLink>
      </Text>
    </DangerAlert>
  );
};

const OrgOnboardingAlert = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <InfoAlert>
      <Text c="primary" fw={500} ta="center">
        <strong>Onboarding in progress.</strong> This account is in setup mode. Operational data will be cleared before going live.
        <Button compact variant="subtle" onClick={() => setIsModalOpen(true)}>
          [Learn More]
        </Button>
      </Text>
      <OrgOnboardingModeModal active={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </InfoAlert>
  );
};

export const GlobalAlert = (): JSX.Element => {
  const { orgIsEnabled, orgIsOnboarding } = useOrg();

  return (
    <>
      {IS_SANDBOX && <SandboxModeAlert />}
      {IS_DEVELOPMENT && <DevelopModeAlert />}
      {orgIsOnboarding && <OrgOnboardingAlert />}
      {!orgIsEnabled && <OrgDisabledAlert />}
    </>
  );
};
